import { AggregatedStatus } from '../../models';
import { ActiveErrorResponse } from '../equipment/equipment.model';
import { SubscriptionPlan } from '../monetization/monetization.model';
import {
  DashboardActiveAnomaliesEnum,
  DashboardAddColumnPayload,
  DashboardAnomaliesNamesEnum,
  DashboardColumn,
  DashboardColumnDataWithoutInstallationDetails,
  DashboardEditColumnPayload,
  DashboardFilterName,
  DashboardFilterPayload,
  DashboardFilterResponse,
  DashboardFilterType,
  DashboardInstallationData,
  DashboardTypeActiveAnomalies,
  DashboardTypeAggregatedStatus,
  SortOrder,
} from './dashboard.api-model';

export namespace DashboardApiMocks {
  export const demoInstallations: DashboardInstallationData[] = [
    //Vitodens 300-W
    {
      id: 10000000,
      device: {
        vin: '7637415001667188',
        marketingName: 'Vitodens 300-W',
        materialImage:
          'https://static.viessmann-climatesolutions.com/resources/product_media/4611996VAN01001_1.PNG',
        plans: ['Free'],
      },
      editedAt: new Date(new Date().getTime()),
      connectedAt: new Date(new Date().getTime()),
      devices: [
        {
          vin: '7637415001667188',
          marketingName: 'Vitodens 300-W',
          heatingOperatingModes: [],
          dhwOperatingMode: null,
          heatingServiceTimeBased: null,
          heatingServiceBurnerBased: null,
          roles: ['type:boiler'],
          materialImage:
            'https://static.viessmann-climatesolutions.com/resources/product_media/4612416VAN01001_1.PNG',
          smartNotes: [
            {
              id: 7087,
              status: 'New',
              type: 'device-error',
              content: {
                gatewaySerial: '7637415001667188',
                deviceId: '0',
                modelId: 'E3_Vitodens_300_0421/E3_Dictionary',
                equipmentType: 'Boiler',
                errorEventType: 'Error',
                errorCode: 'F.473',
                appearedAt: '2021-05-26T10:03:20.977Z',
                installationId: 10000000,
              },
              createdAt: '2021-04-22T18:18:16.144Z',
              editedAt: '2021-05-26T10:03:46.571Z',
              targetGroups: ['Maintainer', 'BuildingManager', 'ServiceContractor', 'Operator'],
            },
            {
              id: 7088,
              status: 'New',
              type: 'device-error',
              content: {
                gatewaySerial: '7637415001667188',
                deviceId: '0',
                modelId: 'E3_Vitodens_300_0421/E3_Dictionary',
                equipmentType: 'Boiler',
                errorEventType: 'Error',
                errorCode: 'F.13',
                errorDescription: 'Regelt nach 0 °C Außentemperatur.',
                appearedAt: '2021-08-10T17:41:03.096Z',
                installationId: 10000000,
              },
              createdAt: '2021-04-22T18:18:16.170Z',
              editedAt: '2021-05-26T10:03:46.571Z',
              targetGroups: ['Maintainer', 'BuildingManager', 'ServiceContractor', 'Operator'],
            },
            {
              id: 7089,
              status: 'New',
              type: 'device-error',
              content: {
                gatewaySerial: '7637415001667188',
                deviceId: 'zigbee-90fd9ffffe4a6521',
                modelId: 'E3_Vitodens_300_0421/E3_Dictionary',
                equipmentType: 'Boiler',
                errorEventType: 'Error',
                errorCode: 'A.27',
                errorDescription: 'Battery capacity of radiator valve too low',
                appearedAt: '2021-08-10T17:41:03.096Z',
                installationId: 10000000,
              },
              createdAt: '2021-04-22T18:18:16.170Z',
              targetGroups: ['Maintainer', 'BuildingManager', 'ServiceContractor', 'Operator'],
            },
            {
              id: 7090,
              status: 'New',
              type: 'device-error',
              content: {
                gatewaySerial: '7637415001667188',
                deviceId: 'zigbee-90fd9ffffe4a5f7f',
                modelId: 'E3_Vitodens_300_0421/E3_Dictionary',
                equipmentType: 'Boiler',
                errorEventType: 'Error',
                errorCode: 'F.732',
                errorDescription: 'Battery capacity of radiator valve critial',
                appearedAt: '2021-08-10T17:41:03.096Z',
                installationId: 10000000,
              },
              createdAt: '2021-04-22T18:18:16.170Z',
              targetGroups: ['Maintainer', 'BuildingManager', 'ServiceContractor', 'Operator'],
            },
          ],
          anomalies: [],
          plans: ['Free'],
        },
      ],
      owner: {
        firstName: 'Finn',
        lastName: 'Goldstein',
        email: 'f.goldstein@example.com',
        mobileNumber: null,
      },
      commercialOwner: null,
      address: {
        street: 'Kolpingstraße',
        houseNumber: '29',
        zip: '49377',
        city: 'Vechta',
        geolocation: {
          latitude: 52.72789,
          longitude: 8.281142,
          timeZone: 'Europe/Berlin',
        },
      },
      installationType: 'Residential',
      description: null,
      aggregatedStatus: 'Error',
      isMultiGateway: false,
      isCascade: false,
      isActiveSmartNote: false,
      isSystemLocked: false,
      amountOfAnomalies: {},
      consumers: [],
      partners: [],
      smartNotes: [],
      plans: ['Free'],
    },
    // Vitodens 200-W
    {
      id: 10000018,
      device: {
        vin: '7722311-device-serial',
        marketingName: 'Vitodens 200-W',
        materialImage:
          'https://static.viessmann-climatesolutions.com/resources/product_media/4611996VAN01001_1.PNG',
        plans: ['Free'],
      },
      editedAt: new Date(new Date().getTime() - 17 * 24 * 60 * 60 * 1000),
      connectedAt: new Date(new Date().getTime() - 18 * 24 * 60 * 60 * 1000),
      devices: [
        {
          vin: '7722311-device-serial',
          marketingName: 'Vitodens 200-W',
          heatingOperatingModes: [],
          dhwOperatingMode: null,
          heatingServiceTimeBased: null,
          heatingServiceBurnerBased: null,
          roles: ['type:boiler'],
          materialImage:
            'https://static.viessmann-climatesolutions.com/resources/product_media/4612958VAN01001_1.PNG',
          smartNotes: [
            {
              id: 7087,
              status: 'New',
              type: 'device-error',
              content: {
                gatewaySerial: '7724820-gw-serial-18',
                deviceId: '0',
                modelId: 'E3_Vitodens_200_0620',
                equipmentType: 'Boiler',
                errorEventType: 'Error',
                errorCode: 'F.370',
                appearedAt: '2021-05-26T10:03:20.977Z',
                installationId: 10000018,
              },
              createdAt: '2021-04-22T18:18:16.144Z',
              editedAt: '2021-05-26T10:03:20.977Z',
              targetGroups: ['Owner', 'FamilyMember', 'Maintainer', 'Support'],
            },
            {
              id: 233423,
              status: 'New',
              type: 'system-locked',
              content: {
                gatewaySerial: '7724820-gw-serial-18',
                deviceId: '0',
                modelId: 'E3_Vitodens_200_0620',
                equipmentType: 'Boiler',
                errorEventType: 'Error',
                errorCode: 'F.117',
                appearedAt: '2021-05-26T10:03:20.977Z',
                installationId: 10000018,
              },
              createdAt: '2021-04-22T18:18:16.144Z',
              editedAt: '2021-05-26T10:03:20.977Z',
              targetGroups: ['Owner', 'FamilyMember', 'Maintainer', 'Support'],
            },
          ],
          anomalies: [],
          plans: ['Free'],
        },
      ],
      owner: {
        firstName: 'Lucas',
        lastName: 'Baum',
        email: 'l.baum@example.com',
        mobileNumber: '49123456789',
      },
      commercialOwner: null,
      address: {
        street: 'Billwerder Neuer Deich',
        houseNumber: '12',
        zip: '95102',
        city: 'Rehau',
        geolocation: {
          latitude: 50.200043,
          longitude: 12.025326,
          timeZone: 'Europe/Berlin',
        },
      },
      installationType: 'Residential',
      description: null,
      aggregatedStatus: 'Error',
      isMultiGateway: false,
      isCascade: false,
      isActiveSmartNote: false,
      isSystemLocked: true,
      amountOfAnomalies: {},
      consumers: [],
      partners: [],
      smartNotes: [],
      plans: ['Free'],
    },
    // Vitocal 200-S
    {
      id: 10000001,
      device: {
        vin: '7637415-gw-serial',
        marketingName: 'Vitocal 200-S',
        materialImage:
          'https://static.viessmann-climatesolutions.com/resources/product_media/4611996VAN01001_1.PNG',
        plans: ['Pro'],
      },
      editedAt: new Date(new Date().getTime() - 23 * 60 * 60 * 1000),
      connectedAt: new Date(new Date().getTime() - 24 * 60 * 60 * 1000),
      subscriptionExpirationDate: new Date(
        new Date().getTime() + 7 * 24 * 60 * 60 * 1000
      ).toISOString(),
      devices: [
        {
          vin: '7637415-gw-serial',
          marketingName: 'Vitocal 200-S',
          heatingOperatingModes: [],
          dhwOperatingMode: null,
          heatingServiceTimeBased: null,
          heatingServiceBurnerBased: null,
          roles: ['type:heatpump'],
          materialImage:
            'https://static.viessmann-climatesolutions.com/resources/product_media/4611996VAN01001_1.PNG',
          smartNotes: [
            {
              id: 23097,
              status: 'New',
              type: 'device-error',
              content: {
                gatewaySerial: '7637415-gw-serial',
                deviceId: '0',
                modelId: 'E3_Vitodens_300_0421',
                equipmentType: 'Boiler',
                errorEventType: 'Error',
                errorCode: 'F.7',
                appearedAt: '2022-04-26T10:51:13.820Z',
                installationId: 10000001,
              },
              createdAt: '2022-04-26T10:51:43.927Z',
              editedAt: '2022-04-26T10:51:43.927Z',
              targetGroups: [
                'Owner',
                'FamilyMember',
                'Maintainer',
                'Support',
                'BuildingManager',
                'ServiceContractor',
                'Operator',
              ],
            },
          ],
          anomalies: [],
          plans: ['Pro'],
        },
      ],
      owner: {
        firstName: 'Robert',
        lastName: 'Holland',
        email: 'r.holland@example.com',
        mobileNumber: '49123456789',
      },
      commercialOwner: null,
      address: {
        street: 'Viessmannstraße',
        houseNumber: '1',
        zip: '35108',
        city: 'Allendorf',
        geolocation: {
          latitude: 51.0300717,
          longitude: 8.6772573,
          timeZone: 'Europe/Berlin',
        },
      },
      installationType: 'Residential',
      description: null,
      aggregatedStatus: 'Error',
      isMultiGateway: false,
      isCascade: false,
      isActiveSmartNote: false,
      isSystemLocked: false,
      amountOfAnomalies: {},
      consumers: [],
      partners: [],
      smartNotes: [],
      plans: ['Pro'],
    },
    // Vitovalor PT2
    {
      id: 10000005,
      device: {
        vin: '7725048-device-serial',
        marketingName: 'Vitovalor PT2',
        materialImage:
          'https://static.viessmann-climatesolutions.com/resources/product_media/4612852VAN01001_1.PNG',
        plans: ['Pro'],
      },
      subscriptionExpirationDate: new Date(
        new Date().getTime() + 24 * 24 * 60 * 60 * 1000
      ).toISOString(),
      editedAt: new Date(new Date().getTime() - 4 * 24 * 60 * 60 * 1000),
      connectedAt: new Date(new Date().getTime() - 5 * 24 * 60 * 60 * 1000),
      devices: [
        {
          vin: '7725048-device-serial',
          marketingName: 'Vitovalor PT2',
          heatingOperatingModes: [],
          dhwOperatingMode: null,
          heatingServiceTimeBased: null,
          heatingServiceBurnerBased: null,
          roles: ['type:boiler'],
          materialImage:
            'https://static.viessmann-climatesolutions.com/resources/product_media/4612852VAN01001_1.PNG',
          smartNotes: [
            {
              id: 23097,
              status: 'New',
              type: 'device-error',
              content: {
                gatewaySerial: '7725048-device-serial',
                deviceId: '0',
                modelId: 'E3_Vitodens_300_0421',
                equipmentType: 'Boiler',
                errorEventType: 'Error',
                errorCode: 'F.7',
                appearedAt: '2022-04-26T10:51:13.820Z',
                installationId: 10000005,
              },
              createdAt: '2022-04-26T10:51:43.927Z',
              editedAt: '2022-04-26T10:51:43.927Z',
              targetGroups: [
                'Owner',
                'FamilyMember',
                'Maintainer',
                'Support',
                'BuildingManager',
                'ServiceContractor',
                'Operator',
              ],
            },
          ],
          anomalies: [],
          plans: ['Pro'],
        },
      ],
      owner: {
        firstName: 'Adam',
        lastName: 'Green',
        email: 'a.green@example.com',
        mobileNumber: '49123456789',
      },
      commercialOwner: null,
      address: {
        street: 'Beetwiese',
        houseNumber: '2',
        zip: '35108',
        city: 'Allendorf',
        geolocation: {
          latitude: 51.025721,
          longitude: 8.6738304,
          timeZone: 'Europe/Berlin',
        },
      },
      installationType: 'Residential',
      description: null,
      aggregatedStatus: 'Error',
      isMultiGateway: false,
      isCascade: false,
      isActiveSmartNote: false,
      isSystemLocked: false,
      amountOfAnomalies: {},
      consumers: [],
      partners: [],
      smartNotes: [],
      plans: ['Pro'],
    },
    // Vitovalor PT2
    {
      id: 10000006,
      device: {
        vin: '7782093-gw-serial',
        marketingName: 'Vitovalor PT2',
        materialImage:
          'https://static.viessmann-climatesolutions.com/resources/product_media/4611996VAN01001_1.PNG',
        plans: ['Free'],
      },
      editedAt: new Date(new Date().getTime() - 5 * 24 * 60 * 60 * 1000),
      connectedAt: new Date(new Date().getTime() - 6 * 24 * 60 * 60 * 1000),
      devices: [
        {
          vin: '7782093-gw-serial',
          marketingName: 'Vitovalor PT2',
          heatingOperatingModes: [],
          dhwOperatingMode: null,
          heatingServiceTimeBased: null,
          heatingServiceBurnerBased: null,
          roles: ['type:boiler'],
          materialImage:
            'https://static.viessmann-climatesolutions.com/resources/product_media/4612852VAN01001_1.PNG',
          smartNotes: [
            {
              id: 7087,
              status: 'New',
              type: 'device-error',
              content: {
                gatewaySerial: '7725048-device-serial',
                deviceId: '0',
                modelId: 'E3_Vitodens_300_0421/E3_Dictionary',
                equipmentType: 'Boiler',
                errorEventType: 'Error',
                errorCode: 'F.341',
                appearedAt: '2021-05-26T10:03:20.977Z',
                installationId: 10000006,
              },
              createdAt: '2021-04-22T18:18:16.144Z',
              editedAt: '2021-05-26T10:03:20.977Z',
              targetGroups: ['Owner', 'FamilyMember', 'Maintainer', 'Support'],
            },
          ],
          anomalies: [],
          plans: ['Free'],
        },
      ],
      owner: {
        firstName: 'Tim',
        lastName: 'Weber',
        email: 't.weber@example.com',
        mobileNumber: '49123456789',
      },
      commercialOwner: null,
      address: {
        street: 'Leipziger Str.',
        houseNumber: '260',
        zip: '34123',
        city: 'Kassel',
        geolocation: {
          latitude: 51.2964888,
          longitude: 9.5413723,
          timeZone: 'Europe/Berlin',
        },
      },
      installationType: 'Residential',
      description: null,
      aggregatedStatus: 'Error',
      isMultiGateway: false,
      isCascade: false,
      isActiveSmartNote: false,
      isSystemLocked: false,
      amountOfAnomalies: {},
      consumers: [],
      partners: [],
      smartNotes: [],
      plans: ['Free'],
    },
    // Vitodens 300-W
    {
      id: 10000008,
      device: {
        vin: '7690296-device-serial',
        marketingName: 'Vitodens 300-W',
        materialImage:
          'https://static.viessmann-climatesolutions.com/resources/product_media/4611996VAN01001_1.PNG',
        plans: ['Pro'],
      },
      subscriptionExpirationDate: new Date(
        new Date().getTime() + 12 * 24 * 60 * 60 * 1000
      ).toISOString(),
      editedAt: new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000),
      connectedAt: new Date(new Date().getTime() - 8 * 24 * 60 * 60 * 1000),
      devices: [
        {
          vin: '7690296-device-serial',
          marketingName: 'Vitodens 300-W',
          heatingOperatingModes: [],
          dhwOperatingMode: null,
          heatingServiceTimeBased: null,
          heatingServiceBurnerBased: null,
          roles: ['type:boiler'],
          materialImage:
            'https://static.viessmann-climatesolutions.com/resources/product_media/4612416VAN01001_1.PNG',
          smartNotes: [
            {
              id: 23097,
              status: 'New',
              type: 'device-error',
              content: {
                gatewaySerial: '7571381-gw-serial',
                deviceId: '0',
                modelId: 'E3_Vitodens_300_0421',
                equipmentType: 'Boiler',
                errorEventType: 'Error',
                errorCode: 'F.7',
                appearedAt: '2021-05-26T10:03:20.977Z',
                installationId: 10000008,
              },
              createdAt: '2021-04-22T18:18:16.144Z',
              editedAt: '2021-05-26T10:03:20.977Z',
              targetGroups: [
                'Owner',
                'FamilyMember',
                'Maintainer',
                'Support',
                'BuildingManager',
                'ServiceContractor',
                'Operator',
              ],
            },
          ],
          anomalies: [
            {
              id: 'fdd_1',
              diagnosisName: 'connection_quality_indicator',
              severity: 'warning',
            },
          ],
          plans: ['Pro'],
        },
      ],
      owner: {
        firstName: 'Felix',
        lastName: 'Fischer',
        email: 'f.fischer@example.com',
        mobileNumber: '49123456789',
      },
      commercialOwner: null,
      address: {
        street: 'Friedrich-Bergius-Ring',
        houseNumber: '14',
        zip: '97076',
        city: 'Würzburg',
        geolocation: {
          latitude: 49.80215,
          longitude: 9.99723,
          timeZone: 'Europe/Berlin',
        },
      },
      installationType: 'Residential',
      description: null,
      aggregatedStatus: 'Error',
      isMultiGateway: false,
      isCascade: false,
      isActiveSmartNote: false,
      isSystemLocked: false,
      amountOfAnomalies: {
        warning: 1,
      },
      consumers: [],
      partners: [],
      smartNotes: [],
      plans: ['Pro'],
    },
    // Vitocal 200-S
    {
      id: 10000009,
      device: {
        vin: '7727496-device-serial',
        marketingName: 'Vitocal 200-S',
        materialImage:
          'https://static.viessmann-climatesolutions.com/resources/product_media/4611996VAN01001_1.PNG',
        plans: ['Free'],
      },
      editedAt: new Date(new Date().getTime() - 8 * 24 * 60 * 60 * 1000),
      connectedAt: new Date(new Date().getTime() - 9 * 24 * 60 * 60 * 1000),
      devices: [
        {
          vin: '7727496-device-serial',
          marketingName: 'Vitocal 200-S',
          heatingOperatingModes: [],
          dhwOperatingMode: null,
          heatingServiceTimeBased: null,
          heatingServiceBurnerBased: null,
          roles: ['type:boiler'],
          materialImage:
            'https://static.viessmann-climatesolutions.com/resources/product_media/4611996VAN01001_1.PNG',
          smartNotes: [
            {
              id: 7087,
              status: 'New',
              type: 'device-error',
              content: {
                gatewaySerial: '7637419-gw-serial',
                deviceId: '0',
                modelId: 'E3_Vitodens_300_0421/E3_Dictionary',
                equipmentType: 'Boiler',
                errorEventType: 'Error',
                errorCode: 'F.10',
                appearedAt: '2021-05-26T10:03:20.977Z',
                installationId: 10000009,
              },
              createdAt: '2021-04-22T18:18:16.144Z',
              editedAt: '2021-05-26T10:03:20.977Z',
              targetGroups: ['Owner', 'FamilyMember', 'Maintainer', 'Support'],
            },
          ],
          anomalies: [],
          plans: ['Free'],
        },
      ],
      owner: {
        firstName: 'Robert',
        lastName: 'Holland',
        email: 'r.holland@example.com',
        mobileNumber: '49123456789',
      },
      commercialOwner: null,
      address: {
        street: 'Viessmannstraße',
        houseNumber: '1',
        zip: '35108',
        city: 'Allendorf',
        geolocation: {
          latitude: 51.0300717,
          longitude: 8.6772573,
          timeZone: 'Europe/Berlin',
        },
      },
      installationType: 'Residential',
      description: null,
      aggregatedStatus: 'Error',
      isMultiGateway: false,
      isCascade: false,
      isActiveSmartNote: false,
      isSystemLocked: false,
      amountOfAnomalies: {},
      consumers: [],
      partners: [],
      smartNotes: [],
      plans: ['Free'],
    },
    // Vitoair FS
    {
      id: 10000014,
      device: {
        vin: '7892763-device-serial',
        marketingName: 'Vitoair FS',
        materialImage:
          'https://static.viessmann-climatesolutions.com/resources/product_media/4611996VAN01001_1.PNG',
        plans: ['Pro'],
      },
      subscriptionExpirationDate: new Date(
        new Date().getTime() + 15 + 3 * 24 * 60 * 60 * 1000
      ).toISOString(),
      editedAt: new Date(new Date().getTime() - 13 * 24 * 60 * 60 * 1000),
      connectedAt: new Date(new Date().getTime() - 14 * 24 * 60 * 60 * 1000),
      devices: [
        {
          vin: '7892763-device-serial',
          marketingName: 'Vitoair FS',
          heatingOperatingModes: [],
          dhwOperatingMode: null,
          heatingServiceTimeBased: null,
          heatingServiceBurnerBased: null,
          roles: ['type:E3', 'type:product;ViAir_300', 'type:ventilation'],
          materialImage:
            'https://static.viessmann-climatesolutions.com/resources/product_media/4614679VAN01001_1.PNG',
          smartNotes: [
            {
              id: 87159,
              status: 'New',
              type: 'device-error',
              content: {
                gatewaySerial: '7949720-gw-serial-14',
                deviceId: '0',
                modelId: 'E3_ViAir_300F_0821',
                equipmentType: 'Boiler',
                errorEventType: 'Error',
                errorCode: 'F.520',
                appearedAt: '2021-05-26T10:03:20.977Z',
                installationId: 10000014,
              },
              createdAt: '2021-04-22T18:18:16.144Z',
              editedAt: '2021-05-26T10:03:20.977Z',
              targetGroups: [
                'Owner',
                'FamilyMember',
                'Maintainer',
                'Support',
                'BuildingManager',
                'ServiceContractor',
                'Operator',
              ],
            },
          ],
          anomalies: [
            {
              id: 'fdd_1',
              diagnosisName: 'connection_quality_indicator',
              severity: 'warning',
            },
          ],
          plans: ['Pro'],
        },
      ],
      owner: {
        firstName: 'Victoria',
        lastName: 'Ester',
        email: 'v.Ester@example.com',
        mobileNumber: '49444331645',
      },
      commercialOwner: null,
      address: {
        street: 'Kolpingstraße',
        houseNumber: '45',
        zip: '50-230',
        city: 'Wroclaw',
        geolocation: {
          latitude: 52.72789,
          longitude: 8.281142,
          timeZone: 'Europe/Warsaw',
        },
      },
      installationType: 'Residential',
      description: null,
      aggregatedStatus: 'Error',
      isMultiGateway: false,
      isCascade: false,
      isActiveSmartNote: false,
      isSystemLocked: false,
      amountOfAnomalies: {
        warning: 1,
      },
      consumers: [],
      partners: [],
      smartNotes: [],
      plans: ['Pro'],
    },
    // Vitodens 200-W
    {
      id: 10000007,
      device: {
        vin: '7570781-device-serial',
        marketingName: 'Vitodens 200-W',
        materialImage:
          'https://static.viessmann-climatesolutions.com/resources/product_media/4612958VAN01001_1.PNG',
        plans: ['Basic'],
      },
      editedAt: new Date(new Date().getTime() - 6 * 24 * 60 * 60 * 1000),
      connectedAt: new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000),
      devices: [
        {
          vin: '7570781-device-serial',
          marketingName: 'Vitodens 200-W',
          heatingOperatingModes: [],
          dhwOperatingMode: null,
          heatingServiceTimeBased: null,
          heatingServiceBurnerBased: null,
          roles: [
            'capability:backup;0002_HMU_VD2',
            'capability:monetization;AdvancedReport',
            'type:E3',
            'type:boiler',
            'type:product;Vitodens_200',
          ],
          materialImage:
            'https://static.viessmann-climatesolutions.com/resources/product_media/4612958VAN01001_1.PNG',
          smartNotes: [],
          anomalies: [],
          plans: ['Basic'],
        },
      ],
      owner: {
        firstName: 'Daniel',
        lastName: 'Foster',
        email: 'd.foster@example.com',
        mobileNumber: '49123456789',
      },
      commercialOwner: null,
      address: {
        street: 'Viessmannstraße',
        houseNumber: '1',
        zip: '87787',
        city: 'Wolfertschwenden',
        geolocation: {
          latitude: 47.8891336,
          longitude: 10.2469629,
          timeZone: 'Europe/Berlin',
        },
      },
      installationType: 'Residential',
      description: null,
      aggregatedStatus: 'Maintenance',
      isMultiGateway: false,
      isCascade: false,
      isActiveSmartNote: false,
      isSystemLocked: false,
      amountOfAnomalies: {},
      consumers: [],
      partners: [],
      smartNotes: [],
      plans: ['Basic'],
    },
    // Vitocal 200-S
    {
      id: 10000002,
      device: {
        vin: '7733737-device-serial',
        marketingName: 'Vitocal 200-S',
        materialImage:
          'https://static.viessmann-climatesolutions.com/resources/product_media/4611996VAN01001_1.PNG',
        plans: ['Basic'],
      },
      editedAt: new Date(new Date().getTime() - 1 * 24 * 60 * 60 * 1000),
      connectedAt: new Date(new Date().getTime() - 2 * 24 * 60 * 60 * 1000),
      devices: [
        {
          vin: '7733737-device-serial',
          marketingName: 'Vitocal 200-S',
          heatingOperatingModes: [],
          dhwOperatingMode: null,
          heatingServiceTimeBased: null,
          heatingServiceBurnerBased: null,
          roles: ['type:boiler'],
          materialImage:
            'https://static.viessmann-climatesolutions.com/resources/product_media/4611996VAN01001_1.PNG',
          smartNotes: [],
          anomalies: [],
          plans: ['Basic'],
        },
      ],
      owner: {
        firstName: 'Erik',
        lastName: 'Fox',
        email: 'e.fox@example.com',
        mobileNumber: '49123456789',
      },
      commercialOwner: null,
      address: {
        street: 'Str. der Nationen',
        houseNumber: '7',
        zip: '30539',
        city: 'Hannover',
        geolocation: {
          latitude: 52.3169917,
          longitude: 9.8169822,
          timeZone: 'Europe/Budapest',
        },
      },
      installationType: 'Residential',
      description: null,
      aggregatedStatus: 'Offline',
      isMultiGateway: false,
      isCascade: false,
      isActiveSmartNote: false,
      isSystemLocked: false,
      amountOfAnomalies: {},
      consumers: [],
      partners: [],
      smartNotes: [],
      plans: ['Basic'],
    },
    // Vitodens 343-F
    {
      id: 10000004,
      device: {
        vin: '7570953-device-serial',
        marketingName: 'Vitodens 343-F',
        materialImage:
          'https://static.viessmann-climatesolutions.com/resources/product_media/4612527VAN01001_1.PNG',
        plans: ['Basic'],
      },
      editedAt: new Date(new Date().getTime() - 3 * 24 * 60 * 60 * 1000),
      connectedAt: new Date(new Date().getTime() - 4 * 24 * 60 * 60 * 1000),
      devices: [
        {
          vin: '7570953-device-serial',
          marketingName: 'Vitodens 343-F',
          heatingOperatingModes: [],
          dhwOperatingMode: null,
          heatingServiceTimeBased: null,
          heatingServiceBurnerBased: null,
          roles: ['type:boiler'],
          materialImage:
            'https://static.viessmann-climatesolutions.com/resources/product_media/4612527VAN01001_1.PNG',
          smartNotes: [],
          anomalies: [],
          plans: ['Basic'],
        },
      ],
      owner: {
        firstName: 'Frank',
        lastName: 'Hansen',
        email: 'f.hansen@example.com',
        mobileNumber: '49123456789',
      },
      commercialOwner: null,
      address: {
        street: 'Röddenauer Straße',
        houseNumber: '12',
        zip: '35066',
        city: 'Frankenberg',
        geolocation: {
          latitude: 51.0564641,
          longitude: 8.7872125,
          timeZone: 'Europe/Berlin',
        },
      },
      installationType: 'Residential',
      description: null,
      aggregatedStatus: 'WorksProperly',
      isMultiGateway: false,
      isCascade: false,
      isActiveSmartNote: false,
      isSystemLocked: false,
      amountOfAnomalies: {},
      consumers: [],
      partners: [],
      smartNotes: [],
      plans: ['Basic'],
    },
    // Vitodens 100-W
    {
      id: 10000003,
      device: {
        vin: '7570694-device-serial',
        marketingName: 'Vitodens 100-W',
        materialImage:
          'https://static.viessmann-climatesolutions.com/resources/product_media/4613432VAN01001_1.PNG',
        plans: ['Plus'],
      },
      editedAt: new Date(new Date().getTime() - 2 * 24 * 60 * 60 * 1000),
      connectedAt: new Date(new Date().getTime() - 3 * 24 * 60 * 60 * 1000),
      subscriptionExpirationDate: new Date(new Date().getTime() + 3 * 24 * 60 * 60 * 1000),
      devices: [
        {
          vin: '7570694-device-serial',
          marketingName: 'Vitodens 100-W',
          heatingOperatingModes: [],
          dhwOperatingMode: null,
          heatingServiceTimeBased: null,
          heatingServiceBurnerBased: null,
          roles: ['type:boiler'],
          materialImage:
            'https://static.viessmann-climatesolutions.com/resources/product_media/4613432VAN01001_1.PNG',
          smartNotes: [],
          anomalies: [],
          plans: ['Plus'],
        },
      ],
      owner: {
        firstName: 'Martin',
        lastName: 'Gilbert',
        email: 'm.gilbert@example.com',
        mobileNumber: '49123456789',
      },
      commercialOwner: null,
      address: {
        street: 'Kurhessenstraße',
        houseNumber: '2',
        zip: '64546',
        city: 'Mörfelden-Walldorf',
        geolocation: {
          latitude: 49.98692,
          longitude: 8.57743,
          timeZone: 'Europe/Berlin',
        },
      },
      installationType: 'Residential',
      description: null,
      aggregatedStatus: 'WorksProperly',
      isMultiGateway: false,
      isCascade: false,
      isActiveSmartNote: false,
      isSystemLocked: false,
      amountOfAnomalies: {},
      consumers: [],
      partners: [],
      smartNotes: [],
      plans: ['Plus'],
    },
    // Vitoligno 300-C
    {
      id: 10000011,
      device: {
        vin: '7202733-device-serial',
        marketingName: 'Vitoligno 300-C',
        materialImage:
          'https://static.viessmann-climatesolutions.com/resources/product_media/4611478VAN01001_1.PNG',
        plans: ['Basic'],
      },
      editedAt: new Date(new Date().getTime() - 10 * 24 * 60 * 60 * 1000),
      connectedAt: new Date(new Date().getTime() - 11 * 24 * 60 * 60 * 1000),
      devices: [
        {
          vin: '7202733-device-serial',
          marketingName: 'Vitoligno 300-C',
          heatingOperatingModes: [],
          dhwOperatingMode: null,
          heatingServiceTimeBased: null,
          heatingServiceBurnerBased: null,
          roles: ['type:boiler', 'type:legacy', 'type:renewable', 'type:product;Ecotronic'],
          materialImage:
            'https://static.viessmann-climatesolutions.com/resources/product_media/4611478VAN01001_1.PNG',
          smartNotes: [],
          anomalies: [],
          plans: ['Basic'],
        },
      ],
      owner: {
        firstName: 'Frank',
        lastName: 'Fox',
        email: 'f.fox@example.com',
        mobileNumber: '49123456789',
      },
      commercialOwner: null,
      address: {
        street: 'Kolpingstraße',
        houseNumber: '45',
        zip: '50-230',
        city: 'Wroclaw',
        geolocation: {
          latitude: 52.72789,
          longitude: 8.281142,
          timeZone: 'Europe/Berlin',
        },
      },
      installationType: 'Residential',
      description: null,
      aggregatedStatus: 'WorksProperly',
      isMultiGateway: false,
      isCascade: false,
      isActiveSmartNote: false,
      isSystemLocked: false,
      amountOfAnomalies: {},
      consumers: [],
      partners: [],
      smartNotes: [],
      plans: ['Basic'],
    },
    // Vitocharge VX3
    {
      id: 10000015,
      device: {
        vin: '7727518-device-serial',
        marketingName: 'Vitocharge VX3',
        materialImage:
          'https://static.viessmann-climatesolutions.com/resources/product_media/4613422VAN01001_1.PNG',
        plans: ['Basic'],
      },
      editedAt: new Date(new Date().getTime() - 14 * 24 * 60 * 60 * 1000),
      connectedAt: new Date(new Date().getTime() - 15 * 24 * 60 * 60 * 1000),
      devices: [
        {
          vin: '7727518-device-serial',
          marketingName: 'Vitocharge VX3',
          heatingOperatingModes: [],
          dhwOperatingMode: null,
          heatingServiceTimeBased: null,
          heatingServiceBurnerBased: null,
          roles: ['type:E3', 'type:ess', 'type:photovoltaic;Internal', 'type:product;Vitocharge'],
          materialImage:
            'https://static.viessmann-climatesolutions.com/resources/product_media/4613422VAN01001_1.PNG',
          smartNotes: [],
          anomalies: [],
          plans: ['Basic'],
        },
      ],
      owner: {
        firstName: 'Elisabeth',
        lastName: 'Phoenix',
        email: 'e.Phoenix@example.com',
        mobileNumber: '49123456789',
      },
      commercialOwner: null,
      address: {
        street: 'Viessmannstraße',
        houseNumber: '3',
        zip: '35108',
        city: 'Allendorf',
        geolocation: {
          latitude: 40.650002,
          longitude: -73.949997,
          timeZone: 'Europe/Berlin',
        },
      },
      installationType: 'Residential',
      description: null,
      aggregatedStatus: 'WorksProperly',
      isMultiGateway: false,
      isCascade: false,
      isActiveSmartNote: false,
      isSystemLocked: false,
      amountOfAnomalies: {},
      consumers: [],
      partners: [],
      smartNotes: [],
      plans: ['Basic'],
    },
    // Vitocal 222-S
    {
      id: 10000016,
      device: {
        vin: '7637410-gw-serial-16',
        marketingName: 'Vitocal 222-S',
        materialImage:
          'https://static.viessmann-climatesolutions.com/resources/product_media/4613888VAN01001_1.PNG',
        plans: ['Pro'],
      },
      editedAt: new Date(new Date().getTime() - 14 * 24 * 60 * 60 * 1000),
      connectedAt: new Date(new Date().getTime() - 15 * 24 * 60 * 60 * 1000),
      devices: [
        {
          vin: '7637410-gw-serial-16',
          marketingName: 'Vitocal 222-S',
          heatingOperatingModes: [],
          dhwOperatingMode: null,
          heatingServiceTimeBased: null,
          heatingServiceBurnerBased: null,
          roles: ['type:heatpump', 'type:E3', 'type:product;CU401B'],
          materialImage:
            'https://static.viessmann-climatesolutions.com/resources/product_media/4613888VAN01001_1.PNG',
          smartNotes: [],
          anomalies: [],
          plans: ['Pro'],
        },
      ],
      owner: {
        firstName: 'Robbe',
        lastName: 'Elisa',
        email: 'e.Phoenix@example.com',
        mobileNumber: '49123456789',
      },
      commercialOwner: null,
      address: {
        street: 'Augsburger Straße',
        houseNumber: '89',
        zip: '45529 ',
        city: 'Hattingen Niederbonsfeld',
        geolocation: {
          latitude: 51.359223,
          longitude: 7.1294,
          timeZone: 'Europe/Berlin',
        },
      },
      installationType: 'Residential',
      description: null,
      aggregatedStatus: 'WorksProperly',
      isMultiGateway: false,
      isCascade: false,
      isActiveSmartNote: false,
      isSystemLocked: false,
      amountOfAnomalies: {},
      consumers: [],
      partners: [],
      smartNotes: [],
      plans: ['Pro'],
    },
    // Vitocal 222-S
    {
      id: 10000017,
      device: {
        vin: '7736170-gw-serial-17',
        marketingName: 'Vitocal 222-S',
        plans: ['Pro'],
        materialImage:
          'https://static.viessmann-climatesolutions.com/resources/product_media/4613888VAN01001_1.PNG',
      },
      editedAt: new Date(new Date().getTime() - 14 * 24 * 60 * 60 * 1000),
      connectedAt: new Date(new Date().getTime() - 15 * 24 * 60 * 60 * 1000),
      devices: [
        {
          vin: '7736170-gw-serial-17',
          marketingName: 'Vitocal 222-S',
          heatingOperatingModes: [],
          dhwOperatingMode: null,
          heatingServiceTimeBased: null,
          heatingServiceBurnerBased: null,
          roles: ['type:heatpump', 'type:E3', 'type:product;CU401B'],
          materialImage:
            'https://static.viessmann-climatesolutions.com/resources/product_media/4613888VAN01001_1.PNG',
          smartNotes: [],
          anomalies: [],
          plans: ['Pro'],
        },
      ],
      owner: {
        firstName: 'Remy',
        lastName: 'Huurman',
        email: 'e.Phoenix@example.com',
        mobileNumber: '49123456789',
      },
      commercialOwner: null,
      address: {
        street: 'Güntzelstrasse ',
        houseNumber: '44',
        zip: '54413',
        city: 'Damflos',
        geolocation: {
          latitude: 49.777032,
          longitude: 6.942805,
          timeZone: 'Europe/Berlin',
        },
      },
      installationType: 'Residential',
      description: null,
      aggregatedStatus: 'WorksProperly',
      isMultiGateway: false,
      isCascade: false,
      isActiveSmartNote: false,
      isSystemLocked: false,
      amountOfAnomalies: {},
      consumers: [],
      partners: [],
      smartNotes: [],
      plans: ['Pro'],
    },
    // Vitocal 250-A
    {
      id: 10000012,
      device: {
        vin: '7736172-gw-serial-12',
        marketingName: 'Vitocal 250-A',
        materialImage:
          'https://static.viessmann-climatesolutions.com/resources/product_media/4613882VAN01001_1.PNG',
        plans: ['Basic'],
      },
      editedAt: new Date(new Date().getTime() - 14 * 24 * 60 * 60 * 1000),
      connectedAt: new Date(new Date().getTime() - 15 * 24 * 60 * 60 * 1000),
      devices: [
        {
          vin: '7736172-gw-serial-12',
          marketingName: 'Vitocal 250-A',
          heatingOperatingModes: [],
          dhwOperatingMode: null,
          heatingServiceTimeBased: null,
          heatingServiceBurnerBased: null,
          roles: [
            'capability:backup;0020_HPMU_VC',
            'type:E3',
            'type:cascadeV2Lead',
            'type:heatpump',
            'type:product;Vitocal_250',
          ],
          materialImage:
            'https://static.viessmann-climatesolutions.com/resources/product_media/4613882VAN01001_1.PNG',
          smartNotes: [],
          anomalies: [],
          plans: ['Basic'],
        },
        {
          vin: '7949719-gw-serial-12',
          marketingName: 'Ecowater Vitoset Aqua 19D',
          heatingOperatingModes: [],
          dhwOperatingMode: null,
          heatingServiceTimeBased: null,
          heatingServiceBurnerBased: null,
          roles: [
            'type:E3',
            'type:product;VitosetAqua',
            'type:water;leakageDetection',
            'type:water;softener',
          ],
          materialImage: '',
          smartNotes: [],
          anomalies: [],
          plans: ['Basic'],
        },
      ],
      owner: {
        firstName: 'New',
        lastName: 'Franklin',
        email: 'franklin.new@example.com',
        mobileNumber: '',
      },
      commercialOwner: null,
      address: {
        street: 'Viessmannstraße',
        houseNumber: '2',
        zip: '35108',
        city: 'Allendorf',
        geolocation: {
          latitude: 51.0300717,
          longitude: 8.6772573,
          timeZone: 'Europe/Berlin',
        },
      },
      installationType: 'Residential',
      description: null,
      aggregatedStatus: 'WorksProperly',
      isMultiGateway: true,
      isCascade: false,
      isActiveSmartNote: false,
      isSystemLocked: false,
      amountOfAnomalies: {},
      consumers: [],
      partners: [],
      smartNotes: [],
      plans: ['Basic'],
    },
    // Vitocharge
    {
      id: 10000010,
      device: {
        vin: '7724827-gw-serial-10',
        marketingName: 'Vitocharge',
        materialImage:
          'https://static.viessmann-climatesolutions.com/resources/product_media/4613422VAN01001_1.PNG',
        plans: ['Pro'],
      },
      editedAt: new Date(new Date().getTime() - 14 * 24 * 60 * 60 * 1000),
      connectedAt: new Date(new Date().getTime() - 15 * 24 * 60 * 60 * 1000),
      devices: [
        {
          vin: '7724827-gw-serial-10',
          marketingName: 'Vitocharge',
          heatingOperatingModes: [],
          dhwOperatingMode: null,
          heatingServiceTimeBased: null,
          heatingServiceBurnerBased: null,
          roles: [
            'type:E3',
            'type:cascadeV2Lag',
            'type:ess',
            'type:photovoltaic:Internal',
            'type:product;Vitocharge',
          ],
          materialImage:
            'https://static.viessmann-climatesolutions.com/resources/product_media/4613422VAN01001_1.PNG',
          smartNotes: [],
          anomalies: [],
          plans: ['Basic'],
        },
      ],
      owner: {
        firstName: 'Biggie',
        lastName: 'Smalls',
        email: 'b.smalls@example.com',
        mobileNumber: '+49 123456789',
      },
      commercialOwner: null,
      address: {
        street: 'Beetwiese',
        houseNumber: '1',
        zip: '35108',
        city: 'Allendorf',
        geolocation: {
          latitude: 40.650002,
          longitude: -73.949997,
          timeZone: 'Europe/Berlin',
        },
      },
      installationType: 'Residential',
      description: null,
      aggregatedStatus: 'WorksProperly',
      isMultiGateway: false,
      isCascade: false,
      isActiveSmartNote: false,
      isSystemLocked: false,
      amountOfAnomalies: {},
      consumers: [],
      partners: [],
      smartNotes: [],
      plans: ['Pro'],
    },
    // Vitocal 252-A
    {
      id: 10000013,
      device: {
        vin: '7637416-gw-serial',
        marketingName: 'Vitocal 252-A',
        materialImage:
          'https://static.viessmann-climatesolutions.com/resources/product_media/4613422VAN01001_1.PNG',
        plans: ['Plus'],
      },
      editedAt: new Date(new Date().getTime() - 14 * 24 * 60 * 60 * 1000),
      connectedAt: new Date(new Date().getTime() - 15 * 24 * 60 * 60 * 1000),
      devices: [
        {
          vin: '7637416-gw-serial',
          marketingName: 'Vitocal 252-A',
          heatingOperatingModes: [],
          dhwOperatingMode: null,
          heatingServiceTimeBased: null,
          heatingServiceBurnerBased: null,
          roles: [
            'capability:backup;0020_HPMU_VC',
            'type:E3',
            'type:heatpump',
            'type:product;Vitocal_252_A',
          ],
          materialImage:
            'https://static.viessmann-climatesolutions.com/resources/product_media/4613422VAN01001_1.PNG',
          smartNotes: [],
          anomalies: [],
          plans: ['Plus'],
        },
      ],
      owner: {
        firstName: 'Löwy',
        lastName: 'Rupert',
        email: 'r.lowy@gmail.com',
        mobileNumber: '',
      },
      commercialOwner: null,
      address: {
        street: 'Lilienthalstraße',
        houseNumber: '1',
        zip: '85570',
        city: 'Markt Schwaben',
        geolocation: {
          latitude: 48.2103900386104,
          longitude: 11.850676154038583,
          timeZone: 'Europe/Berlin',
        },
      },
      installationType: 'Residential',
      description: null,
      aggregatedStatus: 'WorksProperly',
      isMultiGateway: false,
      isCascade: false,
      isActiveSmartNote: false,
      isSystemLocked: false,
      amountOfAnomalies: {},
      consumers: [],
      partners: [],
      smartNotes: [],
      plans: ['Plus'],
    },
  ] as DashboardInstallationData[];

  export const installationsWithoutHEMSIds: number[] = [
    10000001,
    10000005,
    10000006,
    10000009,
    10000014,
    10000015,
  ];

  export const installationsWithoutSRCIds: number[] = [
    10000001,
    10000002,
    10000003,
    10000004,
    10000005,
    10000006,
    10000007,
    10000008,
    10000009,
    10000012,
  ];

  export const installationsWithPaidPackages: number[] = [
    10000001,
    10000003,
    10000005,
    10000008,
    10000014,
  ];

  export const lockedInstallations: number[] = [10000018];

  export const installationsWithAnomalies: {
    installationId: number;
    type: DashboardActiveAnomaliesEnum;
  }[] = [
    { installationId: 10000008, type: DashboardActiveAnomaliesEnum.Warning },
    { installationId: 10000014, type: DashboardActiveAnomaliesEnum.Warning },
  ];

  export function getMockedDashboardColumns(
    installations: DashboardInstallationData[] = demoInstallations
  ): DashboardColumn[] {
    const fixedColumnNames: DashboardTypeAggregatedStatus[] = [
      'Error',
      'Offline',
      'Maintenance',
      'WorksProperly',
      'RemoteDiagnosticSession',
      'NbIotConnected',
    ];

    const columns = fixedColumnNames.map((name, id) => ({
      id,
      name,
      installationIds: [],
      installations: [],
      leftNeighbor: id === 0 ? null : id - 1,
      selfDefined: false,
      sortOrder: SortOrder.asc,
      version: `${name}-${id}`,
    })) as DashboardColumn[];

    structuredClone(installations).forEach((installation) => {
      const matchingColumn = columns.find(
        (column) => column.name === installation.aggregatedStatus
      );

      if (matchingColumn) {
        matchingColumn.installations.push(installation);
        matchingColumn.installationIds.push(installation.id);
      }
    });

    return columns;
  }

  export const mockedColumn = {
    id: 0,
    leftNeighbor: null,
    name: 'Column1',
    selfDefined: true,
    sortOrder: SortOrder.asc,
    version: 'version1',
    installations: demoInstallations,
    installationIds: demoInstallations.map((installation) => installation.id),
  };

  export const mockedFilters: DashboardFilterResponse[] = [
    {
      filterName: DashboardFilterName.Fulltext,
      type: DashboardFilterType.TextSearch,
      values: null,
    },
    {
      filterName: DashboardFilterName.ActiveAnomalies,
      type: DashboardFilterType.Complex,
      values: ['information', 'warning', 'critical'],
    },
    {
      filterName: DashboardFilterName.ActiveSmartnote,
      type: DashboardFilterType.Toggle,
      values: null,
    },
    {
      filterName: DashboardFilterName.AggregatedStatus,
      type: DashboardFilterType.Complex,
      values: [
        'Error',
        'Offline',
        'Maintenance',
        'WorksProperly',
        'RemoteDiagnosticSession',
        'NbIotConnected',
      ],
    },
    {
      filterName: DashboardFilterName.AnomaliesNames,
      type: DashboardFilterType.Complex,
      values: [
        DashboardAnomaliesNamesEnum.ConnectionQualityIndicator,
        DashboardAnomaliesNamesEnum.OnlineAvaibilityState,
      ],
    },
    {
      filterName: DashboardFilterName.DhwOperatingMode,
      type: DashboardFilterType.Complex,
      values: ['efficient', 'efficientWithMinComfort', 'off'],
    },
    {
      filterName: DashboardFilterName.HeatingOperatingMode,
      type: DashboardFilterType.Complex,
      values: ['cooling', 'heating', 'heatingCooling', 'standby'],
    },
    {
      filterName: DashboardFilterName.InstallationType,
      type: DashboardFilterType.Complex,
      values: ['Commercial', 'Residential'],
    },
    {
      filterName: DashboardFilterName.HemsActivated,
      type: DashboardFilterType.Toggle,
      values: null,
    },
    {
      filterName: DashboardFilterName.HemsNotActivated,
      type: DashboardFilterType.Toggle,
      values: null,
    },
    {
      filterName: DashboardFilterName.SrcActivated,
      type: DashboardFilterType.Toggle,
      values: null,
    },
    {
      filterName: DashboardFilterName.SrcNotActivated,
      type: DashboardFilterType.Toggle,
      values: null,
    },
    {
      filterName: DashboardFilterName.PaidPackage,
      type: DashboardFilterType.Complex,
      values: ['Free', 'Pro'],
    },
    {
      filterName: DashboardFilterName.ProductName,
      type: DashboardFilterType.Complex,
      values: [
        'Vitoair FS',
        'Vitocal 222-SI',
        'Vitocal 250-A',
        'Vitocal 252-A',
        'Vitocharge VX3',
        'Vitodens 100-W',
        'Vitodens 200-W',
        'Vitodens 222-F',
        'Vitodens 333-F',
        'Vitodens 343-F',
        'Vitovalor 300-P',
        'Vitovalor PT2',
      ],
    },
  ];

  export type DemoFilteringFunction = (
    statuses: string[],
    installations: DashboardInstallationData[]
  ) => DashboardInstallationData[];

  function _filterByAggregatedStatus(
    statuses: AggregatedStatus[],
    installations: DashboardInstallationData[]
  ): DashboardInstallationData[] {
    console.log(statuses, installations);
    return installations.filter((installation) =>
      statuses.some((status) => status === installation.aggregatedStatus)
    );
  }

  function _filterByAnomalyStatus(
    statuses: DashboardTypeActiveAnomalies[],
    installations: DashboardInstallationData[]
  ): DashboardInstallationData[] {
    return installations.filter((installation) =>
      installation.devices.some(
        (device) =>
          device.plans.includes(SubscriptionPlan.Pro) &&
          device?.anomalies?.some((anomaly) =>
            statuses.some((status) => status === anomaly.severity)
          )
      )
    );
  }

  function _filterByText(
    filterValue: string,
    installations: DashboardInstallationData[]
  ): DashboardInstallationData[] {
    return installations.filter((installation) =>
      installation.devices.some(
        (device) =>
          device.vin?.toLowerCase().includes(filterValue) ||
          device.marketingName?.toLowerCase().includes(filterValue) ||
          installation.id.toString()?.toLowerCase().includes(filterValue) ||
          `${installation.owner.firstName} ${installation.owner.lastName}`
            ?.toLowerCase()
            .includes(filterValue) ||
          `${installation.address.city} ${installation.address.street} ${installation.address.houseNumber} ${installation.address.zip}`
            ?.toLowerCase()
            .includes(filterValue)
      )
    );
  }

  // Filtering is done by backend, simulate filtering for some values
  export function applyFilters(
    filters: DashboardFilterPayload,
    inputInstallations = demoInstallations
  ): DashboardInstallationData[] {
    // List of supported filters, each filter group requires a new function
    // If filtering by boolean (non-group) is required it probably will be best to create another array of functions
    // and then create next filter cycles
    const arrayFilters: {
      [key: string]: DemoFilteringFunction;
    } = {
      [DashboardFilterName.ActiveAnomalies]: _filterByAnomalyStatus,
      [DashboardFilterName.AggregatedStatus]: _filterByAggregatedStatus,
    };

    let installations = [...inputInstallations];

    Object.entries(filters).forEach(([key, value]) => {
      // Filters applying multiple values
      if (arrayFilters[key] && Array.isArray(value)) {
        installations = arrayFilters[key](value, installations);
      }
      // Text filter
      if (key === DashboardFilterName.Fulltext && typeof value === 'string') {
        installations = _filterByText(value, installations);
      }
    });

    return installations;
  }

  export function newColumnMock(input: DashboardAddColumnPayload): DashboardColumn {
    return {
      installations: demoInstallations.filter((installation) =>
        input.installations.includes(installation.id)
      ),
      installationIds: input.installations,
      id: input.id,
      leftNeighbor: input.leftNeighbor,
      name: input.name,
      selfDefined: true,
      sortOrder: input.sortOrder,
      version: `${input.name}-${input.id}`,
    } as DashboardColumn;
  }

  export function editedColumnMock(
    input: DashboardEditColumnPayload,
    id: number
  ): DashboardColumnDataWithoutInstallationDetails {
    return {
      installations: input.installations,
      id,
      leftNeighbor: input.leftNeighbor,
      name: input.name,
      selfDefined: true,
      sortOrder: input.sortOrder,
      version: `${input.name}-${id}`,
    } as DashboardColumnDataWithoutInstallationDetails;
  }

  export function getSmartNotes(id: number): ActiveErrorResponse[] {
    const matchingInstallation = demoInstallations.find((installation) => installation.id === id);

    const activeErrorResponse = [] as ActiveErrorResponse[];
    const smartNotes = matchingInstallation?.devices?.[0]?.smartNotes;

    if (smartNotes) {
      smartNotes.forEach((el) => {
        const obj = {
          content: {
            gatewaySerial: el.content.gatewaySerial,
            deviceId: el.content.deviceId,
            errorCode: el.content.errorCode,
            appearedAt: el.content.appearedAt,
            equipmentType: el.content.equipmentType,
            errorDescription: '',
          },

          createdAt: el.content.appearedAt,
          type: el.type,
          status: el.status,
          id: el.id,
        } as ActiveErrorResponse;

        activeErrorResponse.push(obj);
      });
    }

    return activeErrorResponse;
  }
}
